import { gql } from '@apollo/client';

const GET_DISPATCH_REPORT_KERRY = gql`
    query GetCustomWarehouseDispatchedKerryReport {
        getCustomWarehouseDispatchedKerryReport {
            code
            success
            message
            count
            results
        }
    }
  `;

export default GET_DISPATCH_REPORT_KERRY;
